import Axios from "axios";
import { protectedResources } from "../authConfig";
import { withTokenHandling, isTokenExpiredError, handleTokenExpiredLogout } from "../utils/tokenUtils";

// ตั้งค่า Axios interceptors สำหรับจัดการ token expiration ทั่วทั้งแอป
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // ตรวจสอบว่า error มาจาก GetUserBasicInfo API หรือไม่
    const isGetUserBasicInfoCall = error.config?.url?.includes('/GetUserBasicInfo');
    
    // ถ้าเป็น GetUserBasicInfo และได้ 401 ให้ skip การจัดการ token expiration
    // เพราะอาจเป็นการเรียกในช่วงที่ยังไม่ได้ authentication
    if (isGetUserBasicInfoCall && error.response?.status === 401) {
      return Promise.reject(error);
    }
    
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return Promise.reject(new Error("Token expired. Please login again."));
    }
    return Promise.reject(error);
  }
);

const URL =
  protectedResources.apiHRMobile.baseApi +
  "/api/v1/UniformSurvey/GetUserBasicInfo";

export async function UserBasicInfo(emailOrId) {
  if (!emailOrId) {
    throw new Error("The emailOrId field is required.");
  }
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  
  // ถ้าไม่มี token ให้ throw error แทนที่จะส่ง request ที่จะได้ 401
  if (!tokenKey) {
    throw new Error("No access token available. User needs to authenticate.");
  }
  
  const config = { headers: { Authorization: `Bearer ${tokenKey}` } };
  const urlWithParam = `${URL}?emailOrId=${encodeURIComponent(emailOrId)}`;

  try {
    const response = await Axios.get(urlWithParam, config);
    const data = response && response.data ? response.data : {};
    localStorage.setItem("obj_sv_profile", JSON.stringify(data));
    return data;
  } catch (error) {
    // เฉพาะ UserBasicInfo ให้ check เพิ่มเติมว่า error มาจากการที่ยังไม่ได้ login หรือไม่
    if (error.response?.status === 401) {
      // ไม่เรียก handleTokenExpiredLogout() ทันที เพื่อให้ auth flow จัดการเอง
      throw new Error("Authentication required");
    }
    
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
   // throw new Error(error);
  }
}

export async function UniformGetSchedulers(token) {
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  const getData = JSON.parse(localStorage.getItem("obj_sv_profile"));
  const date = new Date();
  const getYear = date.getFullYear();
  const bodyParameters = {};
  try {
    const response = await Axios.get(
      protectedResources.apiHRMobile.baseApi +
        "/api/v1/UniformSurveyBackend/GetUniformSchedule",
      config
    );
    return await response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}

export async function UniformBenefit(selectedAmount, emailOrId) {
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  let params = [];
  if (selectedAmount) {
    params.push(`selectedAmount=${encodeURIComponent(selectedAmount)}`);
  }
  if (emailOrId) {
    params.push(`emailOrId=${encodeURIComponent(emailOrId)}`);
  }
  const queryString = params.length ? `?${params.join("&")}` : "";

  try {
    const url =
      protectedResources.apiHRMobile.baseApi +
      "/api/v1/UniformSurvey/GetUniformBenefit" + queryString;
    const response = await Axios.get(url, config);
    return response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}

export async function GetUniformBenefitIncorrect(params) {
  // ดึง email จาก session/localStorage
  let email;
  try {
    const profile = JSON.parse(localStorage.getItem("obj_sv_profile"));
    email = profile?.email;
  } catch (e) {
    email = undefined;
  }
  if (!email) {
    throw new Error("Email is required for GetUniformBenefitIncorrect and was not found in session.");
  }
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  localStorage.setItem("uniFormType", params.uniFormType);

  // เพิ่ม email เข้าไปใน params ทุกครั้ง
  const paramsWithEmail = { ...params, email };

  try {
    const response = await Axios.post(
      protectedResources.apiHRMobile.baseApi +
        "/api/v1/UniformSurvey/GetUniformBenefitIncorrect",
      paramsWithEmail,
      config
    );
    return await response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}

export async function UniformLastest(token) {
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  const getData = JSON.parse(localStorage.getItem("obj_sv_profile"));

  const bodyParameters = {
    params: {
      employeeId: getData.employeeId,
    },
  };
  try {
    const response = await Axios.get(
      protectedResources.apiHRMobile.baseApi +
        "/api/v1/UniformSurvey/GetUniformSurvey?employeeId=" +
        getData.employeeId,
      config
    );
    return await response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}

export async function GetUniformType(token) {
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  const getData = JSON.parse(localStorage.getItem("obj_sv_profile"));
  const bodyParameters = {
    key: "value",
  };
  try {
    const response = await Axios.get(
      protectedResources.apiHRMobile.baseApi +
        "/api/v1/UniformSurvey/GetUnitFormTypes?type=1",
      config
    );
    return await response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}
export async function GetJoblevels(token) {
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  const getData = JSON.parse(localStorage.getItem("obj_sv_profile"));
  const bodyParameters = {
    key: "value",
  };
  try {
    const response = await Axios.post(
      protectedResources.apiHRMobile.baseApi +
        "/api/v1/UniformSurvey/GetJobLevels",
      bodyParameters,
      config
    );
    return await response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}
export async function SaveSurvey(params) {
  const accessTokenRaw = sessionStorage.getItem("AccessToken");
  const tokenKey = accessTokenRaw ? JSON.parse(accessTokenRaw).value : undefined;
  const config = tokenKey
    ? { headers: { Authorization: `Bearer ${tokenKey}` } }
    : {};

  const getData = JSON.parse(localStorage.getItem("obj_sv_profile"));
  const bodyParameters = params;
  try {
    const response = await Axios.post(
      protectedResources.apiHRMobile.baseApi +
        "/api/v1/UniformSurvey/SetUniformSurvey",
      bodyParameters,
      config
    );
    return await response.data;
  } catch (error) {
    if (isTokenExpiredError(error)) {
      handleTokenExpiredLogout();
      return;
    }
    //throw new Error(error);
  }
}

export async function GetShirtTypeImages(params) {
  switch (params) {
    case "Staff Shirt":
      return "./images/uniformtype/Staff-Shirt.jpg";
    case "Grey Collar":
      return "../images/uniformtype/Grey-Collar.jpg";
    case "Red Collar":
      return "../images/uniformtype/Red-Collar.jpg";
    case "Black Shirt":
      return "../images/uniformtype/Black-Shirt.jpg";
    case "Green Collar":
      return "../images/uniformtype/Green-Collar.jpg";
    case "Maintenance":
      return "../images/uniformtype/Maintenance-Shirt.jpg";
    case "GL Shirt":
      return "../images/uniformtype/GL-Shirt.jpg";
    case "Driver Shirt":
      return "../images/uniformtype/Driver-Shirt.jpg";
    case "TL Shirt":
      return "../images/uniformtype/TL-Shirt.jpg";
  }
}
